<template>
  <div class="auth-container">
    <!-- Left Side - Form -->
    <div class="auth-form-section">
      <h2 class="auth-title">Bienvenido de nuevo!</h2>
      <p class="auth-subtitle">Inicia sesión para el seguimiento de tus notificaciones</p>

      <form @submit.prevent="submit" class="auth-form">
        <input type="email" name="email" v-model="form.email" class="form-control" placeholder="Correo electronico" />
        <input type="password" name="password" v-model="form.password" class="form-control" placeholder="Contraseña" />
        
        <button type="submit" class="auth-button auth-button-primary">Iniciar Sesión</button>
        
        <div class="auth-divider">o Inicia Sesión con</div>
        
        <div class="d-flex justify-content-between">
          <button type="button" class="auth-button-social auth-button-google">Google</button>
          <button type="button" class="auth-button-social auth-button-facebook">Facebook</button>
        </div>
        
        <p class="text-center mt-3">
          ¿Aun no tienes una cuenta? 
          <router-link to="/register">Registrate Ahora</router-link>
        </p>
      </form>
    </div>
    
    <!-- Right Side - Information -->
    <div class="auth-info-section">
      <h2 class="auth-title">Mantente informado con tus notificaciones!</h2>
      <!-- <p class="auth-subtitle">Mantente informado con tus notificaciones</p> -->
      
      <img src="@/assets/images/email-icon.svg" alt="Notificaciones via Email" class="auth-image" />
      
      <p>Accede a todas tus notificiaciones de expedientes en un solo lugar.</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'Login-view',
  data() {
    return {
      form: {
        email: '',
        password:'',
      }
    };
  },
  methods: {
    ...mapActions(['logIn']),
    async submit() {
      const User = {
        email: this.form.email,
        password: this.form.password
      };
      //explaination: The logIn action is dispatched with the User object as an argument.
      await this.logIn(User);
      //explaination: After the user logs in, the user is redirected to the dashboard page.
      this.$router.push('/dashboard');
    }
  }
});
</script>
